module.exports = __webpack_public_path__ + "static/media/success.bc4cf998.svg";